import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import { showAutoApproval } from '@/configurations/actions';
import ApprovalAction from '../components/ApprovalAction';

const AutoApproveAction = ({ show, disabled }) => (
  <ApprovalAction show={show} disabled={disabled} />
);

const mapStateToProps = ({
  configurations: {
    configurations,
  },
}) => ({
  disabled: configurations.all.readStatus === states.PENDING,
});

const mapDispatchToProps = {
  show: showAutoApproval,
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoApproveAction);
